<!--  -->
<template>
  <div class="awemaxin">
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input v-model="query.sp_strategy_no" clearable style="width:280px;margin-right:10px" placeholder="请输入策略编号" />
        <el-input v-model="query.sp_strategy_title" clearable style="width:280px;margin-right:10px" placeholder="请输入策略标题" /> -->
        <el-input v-model="query.corp_keywords" clearable style="width:400px" placeholder="请输入企微id/企微名称" />
        <el-input v-model="query.applet_keywords" clearable style="width:400px;" placeholder="请输入小程序appid/名称" />
        <el-select v-model="query.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增绑定</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
    >
      <el-table-column
        prop="corp_id"
        label="企微id"
        align="center"
        width="320"
      />
      <el-table-column
        prop="corp_name"
        label="企微名称"
        align="center"
        width="200"
      />
      <el-table-column
        prop="account_name"
        label="小程序名称"
        align="center"
        width="150"
      />
      <el-table-column
        prop="app_id"
        label="小程序appid"
        align="center"
        width="200"
      />
      <el-table-column
        prop="app_id"
        label="绑定状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.bind_status === 1"><i class="el-icon-success" style="color:#67c23a" />已绑定</div>
            <div v-if="scope.row.bind_status === 2"><i class="el-icon-error" style="color:#f56c6c" />已解绑</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="绑定时间"
        align="center"
        width="200"
      />
      <el-table-column
        prop="unbind_time"
        label="解绑时间"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.unbind_time !== 0">{{ scope.row.unbind_at_text }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="realName"
        label="操作人"
        align="center"
        width="100"
      />
      <el-table-column
        prop="realName"
        label="操作"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.bind_status === 1" type="warning" size="mini" @click="unbind(scope.row.id)">解绑</el-button>
          <el-button type="danger" size="mini" @click="delter(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="绑定"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="35%"
    >
      <band @updata="updata" />
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { weComApplet, unBinding, delBinding } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import band from './components/band.vue'
export default {
  name: 'EMicroenterprise',
  components: { PaginationRight, band },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        corp_keywords: null,
        applet_keywords: null,
        onlyMe: 2
      },
      loading: false,
      tableData: [],
      total: null,
      dialogVisible: false,
      accountarr: [{
        value: 1,
        label: '查看组内小程序'
      }, {
        value: 2,
        label: '我关联的小程序'
      }]
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  activated() {
    // this.list()
  },
  methods: {
    async list() {
      this.loading = true
      const data = await weComApplet(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.applet_keywords = null
      this.query.corp_keywords = null
      this.list()
    },
    add() {
      this.dialogVisible = true
    },
    unbind(id) {
      console.log(id)
      this.$confirm('确定解绑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        unBinding({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.list()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    delter(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delBinding({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.list()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    updata() {
      this.dialogVisible = false
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.awemaxin{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.el-table .cell{
  flex-direction:row;
  justify-content: center;
}

</style>
